import { render, staticRenderFns } from "./AddSettlementItemAmountForm.vue?vue&type=template&id=b86c283e&"
import script from "./AddSettlementItemAmountForm.vue?vue&type=script&lang=js&"
export * from "./AddSettlementItemAmountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports